var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crm-page"},[_c('CrmBoardApi',{attrs:{"companyId":_vm.companyId,"funnelId":_vm.funnelId,"leadId":_vm.leadId},on:{"openLead":_vm.openLead,"closeLead":_vm.closeLead}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }